import React from "react";
import { connect } from "react-redux";
import { Modal, Form, message, Button, Icon, DatePicker, TimePicker, Input, Tooltip, Select, Spin, Radio, TreeSelect } from 'antd';
import moment from "moment";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicFilter from "../../components/frame/DynamicFilter";
import ReactAbstract from "../../components/abstract/React.abstract";
import LeaveApprovalService from "../../services/Approval/leave-approval-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';
import { fetchLeaveType } from '../../actions/employee-actions';
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
import debounce from 'lodash.debounce';
import applicationCenterService from '../../services/Employee/application-center-service';


const { TextArea } = Input;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
class LeaveManage extends ReactAbstract {

	constructor(props) {
		super(props)
		// 使用 debounce 函数来节流 以 避免 onchange事件的频繁触发 导致页面的频繁重绘
		this.fetchUserList = debounce(this.fetchUserList, 800);
		this.state = {
			currentModalStatus: false,
			currentRelaxionModalStatus: false,
			currentGooutModalStatus: false,
			currentTravelingModalStatus: false,
			currentIndex: null,
			currentData: {},
			currentRelaxionData: {},
			currentDataStatus: "unload",
			filters: {},
			data: [],
			dataStatus: "unload",
			typeTag: '1',
			type: '1',
			isShowLeaveTime:true
		}
	}

	customComponentWillMount() {
		this.props.fetchDepartmentsList();
		this.props.fetchLeaveType();
		this.props.fetchEmployeesList();
	}

	dataMode = 1
	initReload = false
	moduleName = "attendance"
	childModuleName = "LeaveManage"

	// state = {
	// 	currentModalStatus: false,
	// 	currentIndex: null,
	// 	currentData: {},
	// 	currentDataStatus: "unload",
	// 	filters: {},
	// 	data: [],
	// 	dataStatus: "unload",
	// }

	actions = {
		selectAction: LeaveApprovalService.selectLeaveApprovalManage,
		createAction: LeaveApprovalService.createLeaveApproval,
		updateAction: LeaveApprovalService.updateLeaveApproval,
		deleteAction: LeaveApprovalService.deleteLeaveApproval,
		exportAction: LeaveApprovalService.exportLeaveApproval,
		updateRelaxion: LeaveApprovalService.updateLeaveApproval,
	}


	filterColumn = [{
		type: "person"
	}, {
		type: "department"
	},
	{
		type: "select",
		lable: "类型",
		key: "type",
		children: [{ text: "请假" }, { text: "调休" }, { text: "外出" }, { text: "出差" }],
		defaultValue: "请假"
	}, {
		type: "date",
		label: "结束时间",
		key: "search_end_time",
	}, {
		type: "date",
		label: "开始时间",
		key: "search_start_time",
	}
	]

	tableColumn = [{
		title: '工号',
		dataIndex: 'job_number',
		key: 'job_number',
		className: 'table-global-head-small'
	}, {
		title: '中文名',
		dataIndex: 'real_name',
		key: 'real_name',
		className: 'table-global-head-small'
	}, {
		title: '英文名',
		dataIndex: 'english_name',
		key: 'english_name',
		className: 'table-global-head'
	}, {
		title: '部门名称',
		dataIndex: 'department_name',
		key: 'department_name',
		className: 'table-global-head'
	},
	{
		title: '类型',
		dataIndex: 'type_str',
		key: 'type_str',
		className: 'table-global-head'
	}, {
		title: '开始日期',
		dataIndex: 'start_date',
		key: 'start_date',
		className: 'table-global-head-short',
		render: (text) => (<span>{moment(text).format("YYYY-MM-DD")}</span>)
	}, {
		title: '开始时间',
		dataIndex: 'start_time',
		key: 'start_time',
		className: 'table-global-head-short'
	}, {
		title: '结束日期',
		dataIndex: 'end_date',
		key: 'end_date',
		className: 'table-global-head-short',
		render: (text) => (<span>{moment(text).format("YYYY-MM-DD")}</span>)
	}, {
		title: "结束时间",
		dataIndex: 'end_time',
		key: 'end_time',
		className: 'table-global-head-short'
	},
	{
		title: "时长",
		dataIndex: 'duration',
		key: 'duration',
		className: 'table-global-head-small'
	},
	{
		title: '申请原因',
		dataIndex: 'remark',
		key: 'remark',
		className: 'table-global-head'
	}, {
		title: '状态',
		dataIndex: 'approval_status_str',
		key: 'approval_status_str',
		className: 'table-global-head-small'
	}
	]

	insertCurrent = () => {
		this.setState({ currentModalStatus: true });
		// insert
		this.setState({
			currentData: {},
			typeTag: '1'
		});
	}
	//调休
	insertRelaxionCurrent = () => {
		this.setState({ currentRelaxionModalStatus: true });
		// insert
		this.setState({
			currentRelaxionData: {},
			typeTag: '1'
		});
	}
	//外出
	insertGooutCurrent = () => {
		this.setState({ currentGooutModalStatus: true });
		// insert
		this.setState({
			currentGooutData: {},
			typeTag: '1'
		});
	}
	//出差
	insertTravelingCurrent = () => {
		this.setState({ currentTravelingModalStatus: true });
		// insert
		this.setState({
			currentTravelingData: {},
			typeTag: '1'
		});
	}
	toggleCurrentRelaxionModal = () => this.setState({
		currentRelaxionModalStatus: !this.state.currentRelaxionModalStatus
	})
	toggleCurrentGooutModal = () => this.setState({
		currentGooutModalStatus: !this.state.currentGooutModalStatus
	})
	toggleCurrentTravelingModal = () => this.setState({
		currentTravelingModalStatus: !this.state.currentTravelingModalStatus
	})
	publicDelete = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择要删除的内容', 4);
			return false;
		}


		
		Modal.confirm({
			title: '确定删除选中的内容么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				if ("function" === typeof this.actions.deleteAction) {
					this.actions.deleteAction({ ids: this.state.selectedIDs }, res => {
						if (res.data.Success) {
							this.setState({ selectedIDs: [] });
							message.success('删除操作成功', 4);
							this.publicChange();
						} else {
							message.error('删除操作失败' + res.data.Errors[0], 4);
						}
					});
				} else {
					this.handleError('undefined delete action');
				}
			},
			onCancel: () => { }
		});
	}

//导出
publicExport = () => {
	let gets = {};
	Object.keys(this.state.filters).forEach(key => {
		if (this.state.filters[key]) {
			gets[key] = this.state.filters[key];
		}
	})
	delete gets.page;
	let ref = Modal.info({
		content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
	});
	if ("function" === typeof this.actions.exportAction) {
		this.actions.exportAction(gets, res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			}else{
				message.error('导出数据失败, ' + res.data.Errors[0], 4);
			}
		}, err => message.error('导出数据失败, 请联系管理员', 4))
	}else{
		this.handleError("Child class's actions exportAction is required!");
	}
}


	fetchUserList = (params) => {
		this.props.fetchEmployeesList(params)
	}

	handleSearchChange = value => this.props.fetchEmployeesList({ real_name: value })

	selectViewer = (value, obj) => {
		this.setState({
			charge_user_ids: obj.props.data,
			charge_user_names: value
		});
	}

	handleSelectChange = (v) => {
		this.setState({
			groupUser: v
		})
	}

	submitCurrentModal = () => {
		// submit
		this.props.form.validateFields((err, values) => {
			let posts = {
				...values
			};
			if (values.start_date) {
				posts.start_date = values.start_date.format('YYYY-MM-DD')
			}
			if (values.start_time) {
				posts.start_time = values.start_time.format('HH:mm')
			}
			if (values.end_date) {
				posts.end_date = values.end_date.format('YYYY-MM-DD')
			}
			if (values.end_time) {
				posts.end_time = values.end_time.format('HH:mm')
			}
			if (this.state.typeTag === '1') {

			}
			console.log(posts)
			applicationCenterService.learveManager(posts, res => {
				if (res.data.Success) {
					message.success("新增请假操作成功", 4);
					this.props.form.resetFields();
					this.setState({ currentModalStatus: false });
					this.publicChange({}, "reload")
				} else {
					message.error(`新增请假操作失败：${res.data.Errors[0]}`);
				}
			}, err => { });
		})
	}

	submitCurrentRelaxionModal = () => {
		// submit
		this.props.form.validateFields((err, values) => {
			let posts = {
				...values
			};
			if (values.r_start_date) {
				posts.start_date = values.r_start_date.format('YYYY-MM-DD')
			}
			if (values.r_start_time) {
				posts.start_time = values.r_start_time.format('HH:mm')
			}
			if (values.r_end_date) {
				posts.end_date = values.r_end_date.format('YYYY-MM-DD')
			}
			if (values.r_end_time) {
				posts.end_time = values.r_end_time.format('HH:mm')
			}
			posts.employee_ids = values.r_employee_ids;
			posts.department_id = values.r_department_id;
			posts.department_id = values.r_department_id;
			posts.remark = values.r_remark;
			if (this.state.typeTag === '1') {

			}
			console.log(posts)
			applicationCenterService.relaxioneManager(posts, res => {
				if (res.data.Success) {
					message.success("新增调休操作成功", 4);
					this.props.form.resetFields();
					this.setState({ currentRelaxionModalStatus: false });
					this.publicChange({}, "reload")
				} else {
					message.error(`新增调休操作失败：${res.data.Errors[0]}`);
				}
			}, err => { });
		})
	}

	submitCurrentGooutModal = () => {
		// submit
		this.props.form.validateFields((err, values) => {
			let posts = {
				...values
			};
			if (values.g_start_date) {
				posts.start_date = values.g_start_date.format('YYYY-MM-DD')
			}
			if (values.g_start_time) {
				posts.start_time = values.g_start_time.format('HH:mm')
			}
			if (values.g_end_date) {
				posts.end_date = values.g_end_date.format('YYYY-MM-DD')
			}
			if (values.g_end_time) {
				posts.end_time = values.g_end_time.format('HH:mm')
			}
			posts.employee_ids = values.g_employee_ids;
			posts.department_id = values.g_department_id;
			posts.department_id = values.g_department_id;
			posts.remark = values.g_remark;
			if (this.state.typeTag === '1') {

			}
			applicationCenterService.gooutManager(posts, res => {
				if (res.data.Success) {
					message.success("新增操作成功", 4);
					this.props.form.resetFields();
					this.setState({ currentGooutModalStatus: false });
					this.publicChange({}, "reload")
				} else {
					message.error(`新增操作失败：${res.data.Errors[0]}`);
				}
			}, err => { });
		})
	}

	submitCurrentTravelingModal = () => {
		// submit
		this.props.form.validateFields((err, values) => {
			let posts = {
				...values
			};
			if (values.t_start_date) {
				posts.start_date = values.t_start_date.format('YYYY-MM-DD')
			}
			if (values.t_start_time) {
				posts.start_time = values.t_start_time.format('HH:mm')
			}
			if (values.t_end_date) {
				posts.end_date = values.t_end_date.format('YYYY-MM-DD')
			}
			if (values.t_end_time) {
				posts.end_time = values.t_end_time.format('HH:mm')
			}
			posts.employee_ids = values.t_employee_ids;
			posts.department_id = values.t_department_id;
			posts.department_id = values.t_department_id;
			posts.remark = values.t_remark;
			if (this.state.typeTag === '1') {

			}
			applicationCenterService.TravelingManager(posts, res => {
				if (res.data.Success) {
					message.success("新增操作成功", 4);
					this.props.form.resetFields();
					this.setState({ currentTravelingModalStatus: false });
					this.publicChange({}, "reload")
				} else {
					message.error(`新增操作失败：${res.data.Errors[0]}`);
				}
			}, err => { });
		})
	}


	changeAllMember = (v) => {
		console.log(v.target.value);
		this.setState({
			typeTag: v.target.value
		})
	}
	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id}
					key={item.id}
					dataRef={item} >
					{item.children.length !== 0 && this.renderTreeNodes(item.children)}
				</TreeSelect.TreeNode>
			)
		}
		return <TreeSelect.TreeNode {...item} />
	})

	//请假类型更换
	selectLeaveType = (value) => {
		if (value == '1') {
			this.setState({ isShowLeaveTime: false })
		}
	}

	render() {
		const { employeeLeaveType } = this.props.employee;
		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.insertCurrent}>
							<Icon type="plus-circle-o" />
							<span>新增请假</span>
						</Button>
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.insertRelaxionCurrent}>
							<Icon type="plus-circle-o" />
							<span>新增调休</span>
						</Button>
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.insertGooutCurrent}>
							<Icon type="plus-circle-o" />
							<span>新增外出</span>
						</Button>
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.insertTravelingCurrent}>
							<Icon type="plus-circle-o" />
							<span>新增出差</span>
						</Button>
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete-circle-o" />
							<span>批量删除</span>
						</Button>
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.publicExport}>
							<Icon type="cloud-download-o" />
							<span>导出</span>
						</Button>
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<DynamicFilter column={this.filterColumn}
							departmentsList={this.props.departmentStructure.departmentsList}
							value={this.dataSource().filters}
							setFilter={this.publicChange} />
					</div>
				</div>


				<Modal width="800px"
					visible={this.state.currentRelaxionModalStatus}
					title="新增调休"
					destroyOnClose={true}
					onCancel={this.toggleCurrentRelaxionModal}
					onOk={this.submitCurrentRelaxionModal} className="LeaveManageForm">
					<div className="Applys">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="tag" />
								</Tooltip>
								&nbsp;选择类型
				            </span>
						)}>
							<RadioGroup defaultValue={this.state.typeTag} onChange={this.changeAllMember.bind(this)}>
								<RadioButton value="1">全部员工</RadioButton>
								<RadioButton value="2">当前部门</RadioButton>
							</RadioGroup>
						</Form.Item>

						{this.state.typeTag === '1' && <Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="user" />
								</Tooltip>
								&nbsp;调休员工
				            </span>
						)}>
							{this.props.form.getFieldDecorator('r_employee_ids', {
								rules: [{ required: true, message: '请选择员工' }],
							})(<Select
								mode="multiple"
								filterOption={false}
								style={{ width: 360 }}
								notFoundContent={this.props.employeeManagement.fetching ? <Spin size="small" /> : null}
								placeholder="请选择员工"
								onSearch={this.handleSearchChange}
								onSelect={this.selectViewer}
								onChange={this.handleSelectChange}>
								{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
									this.props.employeeManagement.employeeList.Data.map(employee => {
										return (
											<Select.Option key={employee.id} value={employee.id}
												style={{ width: "340px" }}>
												{employee.real_name}
											</Select.Option>)
									})}
							</Select>)}
						</Form.Item>}
						{this.state.typeTag === '2' && <Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="team" />
								</Tooltip>
								&nbsp;调休部门
				            </span>
						)}>
							{this.props.form.getFieldDecorator('r_department_id', {
								rules: [{ required: true, message: '请选择部门' }],
							})(<TreeSelect style={{ width: "360px" }}
								allowClear
								placeholder="请选择部门"
								showSearch={false}
								autoExpandParent={true}
								dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
								treeDefaultExpandAll
							>
								{this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
							</TreeSelect>)}
						</Form.Item>}

					</div>
					<div className="">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="question-circle-o" />
								</Tooltip>
								&nbsp;调休类型
				            </span>
						)}>
							{this.props.form.getFieldDecorator('relaxation_type', {
								rules: [{ required: true, message: '请选择调休类型' }],
							})(<Select style={{ width: "360px" }} >
								<Select.Option key={1} value={1} data="普通调休">普通调休 Normal</Select.Option>
								<Select.Option key={2} value={2} data="因公调休">因公调休 Business</Select.Option>
							</Select>)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="calendar" />
								</Tooltip>
								&nbsp;开始时间
				            </span>
						)} style={{ float: "left" }}>
							{this.props.form.getFieldDecorator('r_start_date', {
								rules: [{ required: true, message: '请输入调休开始日期' }],
							})(<DatePicker style={{ width: "180px" }} />)}
						</Form.Item>
						<Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
							{this.props.form.getFieldDecorator('r_start_time', {
								rules: [{ required: true, message: '开始时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "170px" }} />)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="calendar" />
								</Tooltip>
								&nbsp;结束时间
				            </span>
						)} style={{ float: "left" }}>
							{this.props.form.getFieldDecorator('r_end_date', {
								rules: [{ required: true, message: '请输入调休结束日期' }],
							})(<DatePicker style={{ width: "180px" }} />)}
						</Form.Item>
						<Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
							{this.props.form.getFieldDecorator('r_end_time', {
								rules: [{ required: true, message: '结束时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "170px" }} />)}
						</Form.Item>
					</div>

					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="file-text" />
								</Tooltip>
								&nbsp;调休事由
				            </span>
						)}>
							{this.props.form.getFieldDecorator('r_remark', {
								rules: [{ required: true, message: '请输入调休事由' }],
							})(<TextArea rows={4} style={{ display: 'block', width: '360px' }} />)}
						</Form.Item>
					</div>
				</Modal>



				<Modal width="800px"
					visible={this.state.currentGooutModalStatus}
					title="新增外出"
					destroyOnClose={true}
					onCancel={this.toggleCurrentGooutModal}
					onOk={this.submitCurrentGooutModal} className="LeaveManageForm">
					<div className="Applys">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="tag" />
								</Tooltip>
								&nbsp;选择类型
				            </span>
						)}>
							<RadioGroup defaultValue={this.state.typeTag} onChange={this.changeAllMember.bind(this)}>
								<RadioButton value="1">全部员工</RadioButton>
								<RadioButton value="2">当前部门</RadioButton>
							</RadioGroup>
						</Form.Item>

						{this.state.typeTag === '1' && <Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="user" />
								</Tooltip>
								&nbsp;外出员工
				            </span>
						)}>
							{this.props.form.getFieldDecorator('g_employee_ids', {
								rules: [{ required: true, message: '请选择员工' }],
							})(<Select
								mode="multiple"
								filterOption={false}
								style={{ width: 360 }}
								notFoundContent={this.props.employeeManagement.fetching ? <Spin size="small" /> : null}
								placeholder="请选择员工"
								onSearch={this.handleSearchChange}
								onSelect={this.selectViewer}
								onChange={this.handleSelectChange}>
								{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
									this.props.employeeManagement.employeeList.Data.map(employee => {
										return (
											<Select.Option key={employee.id} value={employee.id}
												style={{ width: "340px" }}>
												{employee.real_name}
											</Select.Option>)
									})}
							</Select>)}
						</Form.Item>}
						{this.state.typeTag === '2' && <Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="team" />
								</Tooltip>
								&nbsp;外出部门
				            </span>
						)}>
							{this.props.form.getFieldDecorator('g_department_id', {
								rules: [{ required: true, message: '请选择部门' }],
							})(<TreeSelect style={{ width: "360px" }}
								allowClear
								placeholder="请选择部门"
								showSearch={false}
								autoExpandParent={true}
								dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
								treeDefaultExpandAll
							>
								{this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
							</TreeSelect>)}
						</Form.Item>}

					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="calendar" />
								</Tooltip>
								&nbsp;开始时间
				            </span>
						)} style={{ float: "left" }}>
							{this.props.form.getFieldDecorator('g_start_date', {
								rules: [{ required: true, message: '请输入开始日期' }],
							})(<DatePicker style={{ width: "180px" }} />)}
						</Form.Item>
						<Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
							{this.props.form.getFieldDecorator('g_start_time', {
								rules: [{ required: true, message: '开始时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "170px" }} />)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="calendar" />
								</Tooltip>
								&nbsp;结束时间
				            </span>
						)} style={{ float: "left" }}>
							{this.props.form.getFieldDecorator('g_end_date', {
								rules: [{ required: true, message: '请输入结束日期' }],
							})(<DatePicker style={{ width: "180px" }} />)}
						</Form.Item>
						<Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
							{this.props.form.getFieldDecorator('g_end_time', {
								rules: [{ required: true, message: '结束时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "170px" }} />)}
						</Form.Item>
					</div>

					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="file-text" />
								</Tooltip>
								&nbsp;外出事由
				            </span>
						)}>
							{this.props.form.getFieldDecorator('g_remark', {
								rules: [{ required: true, message: '请输入外出事由' }],
							})(<TextArea rows={4} style={{ display: 'block', width: '360px' }} />)}
						</Form.Item>
					</div>
				</Modal>


				<Modal width="800px"
					visible={this.state.currentTravelingModalStatus}
					title="新增出差"
					destroyOnClose={true}
					onCancel={this.toggleCurrentTravelingModal}
					onOk={this.submitCurrentTravelingModal} className="LeaveManageForm">
					<div className="Applys">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="tag" />
								</Tooltip>
								&nbsp;选择类型
				            </span>
						)}>
							<RadioGroup defaultValue={this.state.typeTag} onChange={this.changeAllMember.bind(this)}>
								<RadioButton value="1">全部员工</RadioButton>
								<RadioButton value="2">当前部门</RadioButton>
							</RadioGroup>
						</Form.Item>

						{this.state.typeTag === '1' && <Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="user" />
								</Tooltip>
								&nbsp;出差员工
				            </span>
						)}>
							{this.props.form.getFieldDecorator('t_employee_ids', {
								rules: [{ required: true, message: '请选择员工' }],
							})(<Select
								mode="multiple"
								filterOption={false}
								style={{ width: 360 }}
								notFoundContent={this.props.employeeManagement.fetching ? <Spin size="small" /> : null}
								placeholder="请选择员工"
								onSearch={this.handleSearchChange}
								onSelect={this.selectViewer}
								onChange={this.handleSelectChange}>
								{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
									this.props.employeeManagement.employeeList.Data.map(employee => {
										return (
											<Select.Option key={employee.id} value={employee.id}
												style={{ width: "340px" }}>
												{employee.real_name}
											</Select.Option>)
									})}
							</Select>)}
						</Form.Item>}
						{this.state.typeTag === '2' && <Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="team" />
								</Tooltip>
								&nbsp;出差部门
				            </span>
						)}>
							{this.props.form.getFieldDecorator('t_department_id', {
								rules: [{ required: true, message: '请选择部门' }],
							})(<TreeSelect style={{ width: "360px" }}
								allowClear
								placeholder="请选择部门"
								showSearch={false}
								autoExpandParent={true}
								dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
								treeDefaultExpandAll
							>
								{this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
							</TreeSelect>)}
						</Form.Item>}

					</div>
					<div className="">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="question-circle-o" />
								</Tooltip>
								&nbsp;出差类型
				            </span>
						)}>
							{this.props.form.getFieldDecorator('Traveling_type', {
								rules: [{ required: true, message: '请选择出差类型' }],
							})(<Select style={{ width: "360px" }}>
								<Select.Option key={1} value={1} data="公出">公出</Select.Option>
								<Select.Option key={2} value={2} data="公出深造">公出深造</Select.Option>
							</Select>)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="calendar" />
								</Tooltip>
								&nbsp;开始时间
				            </span>
						)} style={{ float: "left" }}>
							{this.props.form.getFieldDecorator('t_start_date', {
								rules: [{ required: true, message: '请输入开始日期' }],
							})(<DatePicker style={{ width: "180px" }} />)}
						</Form.Item>
						<Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
							{this.props.form.getFieldDecorator('t_start_time', {
								rules: [{ required: true, message: '开始时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "170px" }} />)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="calendar" />
								</Tooltip>
								&nbsp;结束时间
				            </span>
						)} style={{ float: "left" }}>
							{this.props.form.getFieldDecorator('t_end_date', {
								rules: [{ required: true, message: '请输入结束日期' }],
							})(<DatePicker style={{ width: "180px" }} />)}
						</Form.Item>
						<Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px" }}>
							{this.props.form.getFieldDecorator('t_end_time', {
								rules: [{ required: true, message: '结束时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "170px" }} />)}
						</Form.Item>
					</div>

					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="file-text" />
								</Tooltip>
								&nbsp;出差事由
				            </span>
						)}>
							{this.props.form.getFieldDecorator('t_remark', {
								rules: [{ required: true, message: '请输出差休事由' }],
							})(<TextArea rows={4} style={{ display: 'block', width: '360px' }} />)}
						</Form.Item>
					</div>
				</Modal>


				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="新增请假"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.submitCurrentModal} className="LeaveManageForm">
					<div className="Applys">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="tag" />
								</Tooltip>
								&nbsp;选择类型
				            </span>
						)}>
							<RadioGroup defaultValue={this.state.typeTag} onChange={this.changeAllMember.bind(this)}>
								<RadioButton value="1">全部员工</RadioButton>
								<RadioButton value="2">当前部门</RadioButton>
							</RadioGroup>
						</Form.Item>

						{this.state.typeTag === '1' && <Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="user" />
								</Tooltip>
								&nbsp;请假员工
				            </span>
						)}>
							{this.props.form.getFieldDecorator('employee_ids', {
								rules: [{ required: true, message: '请选择员工' }],
							})(<Select
								mode="multiple"
								filterOption={false}
								style={{ width: 360 }}
								notFoundContent={this.props.employeeManagement.fetching ? <Spin size="small" /> : null}
								placeholder="请选择员工"
								onSearch={this.handleSearchChange}
								onSelect={this.selectViewer}
								onChange={this.handleSelectChange}>
								{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
									this.props.employeeManagement.employeeList.Data.map(employee => {
										return (
											<Select.Option key={employee.id} value={employee.id}
												style={{ width: "340px" }}>
												{employee.real_name}
											</Select.Option>)
									})}
							</Select>)}
						</Form.Item>}
						{this.state.typeTag === '2' && <Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="team" />
								</Tooltip>
								&nbsp;请假部门
				            </span>
						)}>
							{this.props.form.getFieldDecorator('department_id', {
								rules: [{ required: true, message: '请选择部门' }],
							})(<TreeSelect style={{ width: "360px" }}
								allowClear
								placeholder="请选择部门"
								showSearch={false}
								autoExpandParent={true}
								dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
								treeDefaultExpandAll
							>
								{this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
							</TreeSelect>)}
						</Form.Item>}

					</div>
					<div className="">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="question-circle-o" />
								</Tooltip>
								&nbsp;请假类型
				            </span>
						)}>
							{this.props.form.getFieldDecorator('leave_type', {
								rules: [{ required: true, message: '请选择请假类型' }],
							})(<Select style={{ width: "360px" }} onSelect={this.selectLeaveType}>
								{employeeLeaveType && employeeLeaveType.map(v => (
									<Select.Option key={v.value} value={v.value} data={v.text}>{v.text}</Select.Option>
								))
								}
								<Select.Option key='年假' value='1' data='年假'>年假 Year vacation</Select.Option>
							</Select>)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="calendar" />
								</Tooltip>
								&nbsp;开始时间
				            </span>
						)} style={{ float: "left" }}>
							{this.props.form.getFieldDecorator('start_date', {
								rules: [{ required: true, message: '请输入请假开始日期' }],
							})(<DatePicker style={{ width: "180px" }} />)}
						</Form.Item>
						<Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px",visibility:this.state.isShowLeaveTime?"":"hidden" }}>
							{this.props.form.getFieldDecorator('start_time', {
								rules: [{ required: true, message: '开始时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "170px" }} />)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="calendar" />
								</Tooltip>
								&nbsp;结束时间
				            </span>
						)} style={{ float: "left" }}>
							{this.props.form.getFieldDecorator('end_date', {
								rules: [{ required: true, message: '请输入请假结束日期' }],
							})(<DatePicker style={{ width: "180px" }} />)}
						</Form.Item>
						<Form.Item lable=" " style={{ float: "left", marginTop: "4px", marginLeft: "10px",visibility:this.state.isShowLeaveTime?"":"hidden"  }}>
							{this.props.form.getFieldDecorator('end_time', {
								rules: [{ required: true, message: '结束时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "170px" }} />)}
						</Form.Item>
					</div>

					<div className="ApplyDiv">
						<Form.Item label={(
							<span>
								<Tooltip>
									<Icon type="file-text" />
								</Tooltip>
								&nbsp;请假事由
				            </span>
						)}>
							{this.props.form.getFieldDecorator('remark', {
								rules: [{ required: true, message: '请输入请假事由' }],
							})(<TextArea rows={4} style={{ display: 'block', width: '360px' }} />)}
						</Form.Item>
					</div>
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page
						}}
						rowSelection={this.rowSelection}
						setPageFilter={this.publicChange} />
				</div>
			</div>
		)
	}
}

LeaveManage = Form.create()(LeaveManage);

const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure,
		employee: state.employee,
		employeeManagement: state.employeeManagement
	}
}

const mapDispatchToProps = {
	fetchDepartmentsList,
	fetchLeaveType,
	fetchEmployeesList
}

LeaveManage = connect(mapStateToProps, mapDispatchToProps)(LeaveManage);

export default LayoutWrapper(LeaveManage);


// WEBPACK FOOTER //
// ./src/routes/Attendance/LeaveManage.js